import React from 'react';
import dayjs from 'dayjs';
import { useLocalize } from 'localize-react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { DriverDetails } from '../driverDetails/DriverDetails';
import { TransferDetails } from '../transferDetails/TransferDetails';
import { PassengerDetails } from '../passengerDetails/PassengerDetails';
import { TripDetails } from '../tripDetails/TripDetails';
import { MeetingPoint } from '../meetingPoint/MeetingPoint';
import { FAQ } from '../../components/faq/FAQ';
import { TransferCompanyDetails } from '../transferCompanyDetails/TransferCompanyDetails';
import { CancelJourney } from './components/cancelJourney/Canceljourney';
import { UnresolvedAlerts } from '../../../booking/components/UnresolvedAlerts';
import { useMutationCancelJourney } from '../../../../queries/booking/hooks/useMutationCancelJourney';
import '../../journey.scss';

export const JourneyDetails: React.FC<any> = ({ journey, params, refetchJourney, booking, unresolvedAlerts, unresolvedAlertsNotificationProps, handleGetUnresolvedAlerts }) => {
  const flags = useFlags();
  const { translate } = useLocalize();
  const [cancelJourney, { loading: cancelIsLoading }] = useMutationCancelJourney();
  const today = dayjs.utc();
  const freeCancellationDate = dayjs(journey?.cancellationDetails?.freeCancellationUntil);
  const pickupDate = dayjs(journey?.journeyExecutionInfo?.pickupDate);
  const journeyIsCancellable = journey?.cancellationDetails?.cancellable;
  const journeyIsPaid = booking?.prepaid;
  const isFreeCancellationAvailable: boolean = (journeyIsCancellable && freeCancellationDate?.isAfter(today)) || (journey.status === 'PENDING' && pickupDate?.isAfter(today));
  const isBookingCancellationAvailable: boolean = journeyIsPaid || booking.partner?.name === 'TaxiTender' || booking.partner?.communicationPreferences?.sendJourneyCancellationEmails;
  const isCancelled: boolean = journey.status === 'CANCELLED_FREE' || journey.status === 'CANCELLED_WITH_COSTS';
  const isDriverExist = journey?.driver?.name;
  const {
    showAlertResolveNotification,
    alertResolveNotificationMessage,
    alertResolvenotificationVariant,
  } = unresolvedAlertsNotificationProps;
  return (
    <div className={`journey-details ${flags?.showNewDesign ? 'details-ordering' : ''}`}>
      <div className="journey-left-side">
        <UnresolvedAlerts
          unresolvedAlerts={unresolvedAlerts || []}
          showAlertResolveNotification={showAlertResolveNotification}
          alertResolveNotificationMessage={alertResolveNotificationMessage}
          alertResolvenotificationVariant={alertResolvenotificationVariant}
          refetchUnresolvedAlerts={handleGetUnresolvedAlerts}
        />
        {flags?.showNewDesign && isDriverExist && <DriverDetails journey={journey} />}
        {flags?.showNewDesign && !isDriverExist && <TransferCompanyDetails journey={journey} />}
        <TripDetails journey={journey} />
        {flags?.showNewDesign && <PassengerDetails journey={journey} />}
        {!flags?.showNewDesign && !journey.inbound
          && <MeetingPoint journey={journey} />
        }
        {!flags?.showNewDesign && <DriverDetails journey={journey} />}
        {!flags?.showNewDesign && <TransferDetails journey={journey} />}
      </div>
      <div className="journey-right-side">
        {flags?.showNewDesign
          && <MeetingPoint journey={journey} />
        }
        {flags?.showNewDesign && !isDriverExist && <DriverDetails journey={journey} />}
        {flags?.showNewDesign && isDriverExist && <TransferCompanyDetails journey={journey} />}
        {!flags?.showNewDesign && <PassengerDetails journey={journey} />}
        {flags?.showNewDesign && <TransferDetails journey={journey} />}
        {
          flags?.showNewDesign || isCancelled
            ? null
            : isFreeCancellationAvailable && isBookingCancellationAvailable
              ? <CancelJourney
                bodyText={translate('cancelTripConfirm')}
                onConfirm={() => {
                  return cancelJourney({
                    variables: {
                      params: {
                        id: journey.id,
                        reason: 'NOT_NEEDED_ANYMORE',
                      },
                    },
                  })
                    .then(() => {
                      refetchJourney({
                        variables: {
                          id: Number(params.journeyId),
                          bookingCode: params.bookingCode,
                          includeCancellationDetails: true,
                        },
                      });
                    });
                }}
                loading={cancelIsLoading}
              />
              : <CancelJourney
                bodyText={translate('cancelTripPaidBodyText')}
                showConfirm={false}
                onConfirm={() => { }}
              />
        }
        <FAQ status={journey?.status} countryCode={journey?.travellerInfo?.residenceCountryCode}/>
      </div>
    </div>
  );
};
